import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { usePermissions } from "@/contexts/PermissionsContext";
import { setUnauthorized401Handler } from "@/lib/unauthorized401";

/**
 * Wires global axios 401 handling to auth + permissions cleanup.
 * Must render inside AuthProvider and PermissionsProvider.
 */
export default function Unauthorized401Bridge({ children }) {
  const { logout, isLocalDevBypassEnabled } = useAuth();
  const { clearPermissions } = usePermissions();

  useEffect(() => {
    setUnauthorized401Handler(() => {
      if (isLocalDevBypassEnabled()) {
        return;
      }
      clearPermissions();
      logout();
    });
    return () => setUnauthorized401Handler(null);
  }, [clearPermissions, isLocalDevBypassEnabled, logout]);

  return children;
}
